import React, { useEffect, useState } from 'react';
import axios from 'axios';
import socket from '../tools/socke';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
import Modal from './Modal';
import InfoModalDivision from './InfoModalDivision';

const MuestraEstadosDivisiones = () => {
  const [resumen, setResumen] = useState([]);
  const [veoModalData,setVeoModalData]=useState(false)
  const [divisionSeleccionada,setDivisionSeleccionada]=useState([])
  const Usuario=ObtieneDatosCookies()
  const fetchResumen = async () => {
    try {
      const fecha = new Date();
      const anio = fecha.getFullYear();
      const mes = (fecha.getMonth() + 1).toString().padStart(2, '0'); // getMonth() devuelve un valor de 0 a 11, por eso sumamos 1
      const dia = fecha.getDate().toString().padStart(2, '0'); // Asegura que el día tenga dos dígitos
      const fechaFormateada = `${anio}-${mes}-${dia}`;

      const response = await axios.post('https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/resumenAsistenciaTodasDivisiones',{"fecha":fechaFormateada}); // Cambia por tu endpoint real
      setResumen(response.data);
      
    
    } catch (error) {
      console.error('Error al obtener resumen de asistencias:', error);
    }
  };
  useEffect(() => {
    const handlePresenteCadete = () => {
//         console.log("Recibiendo datos...");
        fetchResumen();
    
      };
     
      socket.on('listaPresentes', handlePresenteCadete);
    fetchResumen(); 
    return () => {
        socket.off('listaPresentes', handlePresenteCadete);
      };
    }, []);
const manejoDivision=(datillo)=>{

setDivisionSeleccionada(datillo)
setVeoModalData(true)
}
  return (
    <div className="" style={{ display: "flex", gap: "10px", flexWrap: "wrap",justifyContent: "center", }}>

{(() => {
  const divisionesFiltradas = resumen.filter(division => {
    if (Usuario.sedeID == 1) return true;
    if (Usuario.sedeID == 2) return division.sede == 'Rosario';
    if (Usuario.sedeID == 3) return division.sede == 'Recreo';
    return false;
  });

  if (!divisionesFiltradas.length) {
    return (
      <div
        style={{
          width: "100%",
          textAlign: "center",
          padding: "40px",
          color: "#666",
          fontSize: "18px",
          fontWeight: "500"
        }}
      >
        📭 No hay divisiones aún asignadas a los cadetes
      </div>
    );
  }

const divisionesOrdenadas = [...divisionesFiltradas].sort((a, b) => {

  // 🟣 1. PRIMERO vs SEGUNDO
  const aEsSegundo = a.nombreDivision?.toUpperCase().includes("SEGUNDO");
  const bEsSegundo = b.nombreDivision?.toUpperCase().includes("SEGUNDO");

  if (aEsSegundo !== bEsSegundo) {
    return aEsSegundo - bEsSegundo; 
    // false (Primero) va antes que true (Segundo)
  }

  // 🔵 2. SEDE (Rosario primero)
  const ordenSede = {
    "Rosario": 1,
    "Recreo": 2
  };

  const sedeA = ordenSede[a.sede] || 99;
  const sedeB = ordenSede[b.sede] || 99;

  if (sedeA !== sedeB) {
    return sedeA - sedeB;
  }

  // 🟢 3. NUMERO DE DIVISION
  return Number(a.numeroDivision) - Number(b.numeroDivision);
});



return divisionesOrdenadas.map((division, index) => {

  const esSegundo = division.nombreDivision?.toUpperCase().includes("SEGUNDO");
  const textoPromocion = esSegundo ? "Segundo" : "Primero";
const colorFondo = esSegundo ? "#2c3e50" : "#145a32"; // azul oscuro / verde
const colorTexto = "white";
  return (
    <div
      key={index}
      style={{
        display: "flex",
        flexDirection: "column",
        width: "240px",
        height: "150px",
        borderRadius: "12px",
        alignItems: "center",
        justifyContent: "center",
        padding: "15px",
        border: "1px solid #ddd",
        backgroundColor: "#fff",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        cursor: "pointer",
        margin: "10px",
      }}
    >
      <div style={{ textAlign: "center" }} onClick={() => manejoDivision(division)}>
        <h6
          style={{
         background: colorFondo,
color: colorTexto,
            borderRadius: "15px",
            padding: "5px"
          }}
        >
          División {(division.numeroDivision || "Sin nombre")} ({textoPromocion})
          {Usuario.sedeID == 1 && division.sede ? ` (${division.sede})` : ""}
        </h6>

        <p style={{ fontSize: "14px" }}>
          F. Efectiva: {division.FE} F. Presente: <strong>{division.FP}</strong>
        </p>

        <p style={{ fontSize: "14px" }}>
          F. Ausente:{" "}
          <strong style={{ color: "red" }}>{division.FA}</strong> F. Formar:{" "}
          <strong>{division.FF}</strong>
        </p>
      </div>
    </div>
  );
});
})()}
{veoModalData && divisionSeleccionada ? <>

<Modal isOpen={veoModalData} onClose={()=>setVeoModalData(false)}>
  <div style={{ padding: "20px" }}>

    <InfoModalDivision datos={divisionSeleccionada}/>
   
  </div>
</Modal>
</> : ""}
  </div>
  
  );
};

export default MuestraEstadosDivisiones;

